"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ApplicationContext = require("../../api/ApplicationContext");
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
var _MegaMenuLinks = _interopRequireDefault(require("./MegaMenuLinks"));
var _SimpleMenuLinks = _interopRequireDefault(require("./SimpleMenuLinks"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MenuLinks = _ref => {
  var _site$public;
  let {
    toggleActive,
    isActive,
    site
  } = _ref;
  const publicMenuItems = site === null || site === void 0 || (_site$public = site.public) === null || _site$public === void 0 ? void 0 : _site$public.siteMenu;
  const isAuthenticated = _SecurityContextHolder.SecurityContextHolder.isAuthenticated();
  const isMegaMenu = isAuthenticated && _ApplicationContext.ApplicationContext.isMegaMenu() || !isAuthenticated && _ApplicationContext.ApplicationContext.isPublicMegaMenu();
  if (isMegaMenu) {
    return /*#__PURE__*/_react.default.createElement(_MegaMenuLinks.default, {
      toggleActive: toggleActive,
      isActive: isActive,
      key: `MegaMenuLinks${isAuthenticated}`,
      menuItems: isAuthenticated ? undefined : publicMenuItems
    });
  }
  return /*#__PURE__*/_react.default.createElement(_SimpleMenuLinks.default, {
    toggleActive: toggleActive,
    isActive: isActive,
    key: `MegaMenuLinks${isAuthenticated}`,
    menuItems: isAuthenticated ? undefined : publicMenuItems
  });
};
MenuLinks.propTypes = {
  toggleActive: _propTypes.default.func,
  isActive: _propTypes.default.bool,
  site: _propTypes.default.shape({
    public: _propTypes.default.shape({
      isMegaMenu: _propTypes.default.bool,
      siteMenu: _propTypes.default.array
    })
  })
};
var _default = exports.default = MenuLinks;
//# sourceMappingURL=MenuLinks.js.map